import React, { useState, useEffect } from 'react'
import BrowseCardItem from './BrowseCardItem';
import './PetList.css'
import { getDoc, addDoc, doc, updateDoc, deleteDoc, setDoc, collection, getDocs, query, where, onSnapshot } from "@firebase/firestore";
import {db, storage } from '../firebase-config';
import { ref, uploadBytes, getDownloadURL, listAll } from 'firebase/storage'

const PetList = ({pets, handleAdoption, shelters}) => {

    console.log(shelters)
    const [petImages, setPetImages] = useState({})

    const getPetImages = async () => {

        // get pets
        const petImageRef = ref(storage, 'images/pets/')
        const petRef = collection(db, "pets")
        onSnapshot(petRef, (snapshot) => {
        snapshot.docs.forEach(doc => {
            console.log(Response)
            getDownloadURL(ref(storage, `images/pets/${doc.id}`)).then((url) => {
            setPetImages(prev => ({...prev, [doc.id]: url
            }));
            })
        })
        
        console.log(petImages)
    })
      }
    
    useEffect(() => {
        getPetImages();
      }, []);

    const handleAdoptClick = (e, petID) => {
        const selectedPet = pets.filter((p) => p.id === petID);
        if(selectedPet[0].availability === "available")
            handleAdoption(e, petID);
        else
            alert("This pet is not available.")
    }

    const cards = pets.map((pet, index) => {
        return (
          <div >
            
              <BrowseCardItem
                  key={pet.id}
                  id={pet.id}
                  name={pet.name}
                  shelterID={pet.shelterID}
                  src={petImages[pet.id]}
                  species={pet.species}
                  breed={pet.breed}
                  disposition={pet.disposition}
                  availability={pet.availability}            
                  age={pet.age}
                  handleAdoptClick={handleAdoptClick}
                  shelters={shelters}
              />
            
          </div>
        )
    });

    return (
        <div>
            <h1>Pet List</h1>
            <ul>
                {cards}
            </ul>
        </div>
    )
}

export default PetList